import PropTypes from 'prop-types';
import Modal from 'components/Modal';
import Button from 'components/UI/Button';

/**
 * Componente modular para mostrar alertas cuando se selecciona un tipo de pago específico
 * @param {Object} props
 * @param {boolean} props.show - Controla la visibilidad del modal
 * @param {string} props.title - Título del modal
 * @param {string} props.message - Mensaje a mostrar en el modal
 * @param {string} props.buttonText - Texto del botón de aceptar
 * @param {Function} props.onAccept - Callback cuando se acepta el modal
 * @param {Function} props.onClose - Callback cuando se cierra el modal
 */
const PaymentTypeAlertModal = ({
  show,
  title,
  message,
  buttonText,
  onAccept,
  onClose,
}) => {
  const handleAccept = () => {
    if (onAccept) {
      onAccept();
    }
    if (onClose) {
      onClose();
    }
  };

  if (!show) return null;

  return (
    <Modal
      onClose={onClose}
      showCloseButton={false}
      closeOnBackgroundClick={false}
      title={title}
    >
      <p className='mt-2 mb-4'>{message}</p>
      <Button
        text={buttonText}
        onClick={handleAccept}
        className='mt-4'
        type='primary'
      />
    </Modal>
  );
};

PaymentTypeAlertModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  onAccept: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

PaymentTypeAlertModal.defaultProps = {
  onAccept: null,
};

export default PaymentTypeAlertModal;
